import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appConfig } from './app/app.config';
// AG Grid
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

// Registrar módulos de AG Grid
ModuleRegistry.registerModules([AllCommunityModule]);

bootstrapApplication(App, appConfig)
.catch(err => console.error(err));
